module.exports = __webpack_public_path__ + "img/logo.bf79ee86.png";